module.exports = __webpack_public_path__ + "img/company_head.6c946a70.png";